import { AxiosResponse } from 'axios';
import { ICommonAppSettings } from '../models';
import { IConnectionMonitorService } from '../services/connectionMonitorService';
import { ILoggingService } from '../services/loggingService';
import { ApiDataError, ApiError, CancelError } from './apiBase';
import { ISBApiOperationResponse, SportsBettingApiResult } from './apiCommon';
import axios from 'axios';
import { IDateTimeFormater } from '../services/dateFormater';

export enum AppType {
    FullLive = 0,
    PartialPrematch = 1
}

export interface ISportsBettingSessionBaseApi {
    getServerTimeAsyncForMts: (withTokenCheck?: boolean) => Promise<Date>;
    setToken: (aToken: string) => void;
}

export interface ISportsBettingSessionCommonApi {
    tokenExpired: () => void;
    tokenOk: () => void;
    playerSignInAsync: (params: any) => Promise<any>;
    getServerTimeAsyncForMts: (withTokenCheck?: boolean) => Promise<Date>;
}

export interface ISportsBettingSessionApiForDesktop extends ISportsBettingSessionCommonApi {
    getInitDataAsync: (appType: AppType) => Promise<AxiosResponse<any>>;
}

export interface ISportsBettingSessionApiForMobileWeb extends ISportsBettingSessionCommonApi {
    getInitDataAsync: (lastTokenForMobileAppTipos: string) => Promise<AxiosResponse<any>>;
}

export interface IConnectSportsBettingSessionBaseApiParams {
    baseUrl: string;
    dateTimeFormater: IDateTimeFormater;
    settings: ICommonAppSettings;
    tokenOk: () => void;
    tokenExpired: () => void;
}

export function sportsBettingSessionBaseApi(params: IConnectSportsBettingSessionBaseApiParams, loggingService: ILoggingService, connectionMonitorService: IConnectionMonitorService): ISportsBettingSessionBaseApi {
    const baseUrl = params.baseUrl + '/WebServices/ApiSession/SportsBettingSessionService.svc';
    const languageId = params.settings.language.id;
    let token: string;

    //const dateToString = params.dateTimeFormater.toString;

    const toDate = (date: string) => {
        return params.dateTimeFormater.toDate(date);
    };

    function processApiResponse(response: AxiosResponse<ISBApiOperationResponse<any>>, errorHandler: (reason: Error) => void, canSendSuccessToMonitor: boolean = true): boolean {
        if (response.data.Result == SportsBettingApiResult.Failed) {
            loggingService.error('Request failed', response.data);
            errorHandler(new ApiDataError(SportsBettingApiResult.Failed));
            return false;
        } else {
            if (response.data.Result == SportsBettingApiResult.SessionExpired) {
                params.tokenExpired();
                errorHandler(new ApiDataError(SportsBettingApiResult.SessionExpired));
                return false;
            }
        }
        params.tokenOk();
        if (canSendSuccessToMonitor) {
            connectionMonitorService.heartbeatSuccess();
        }
        return true;
    }

    function processError(error: any, errorHandler: (reason: any) => void) {
        if (axios.isCancel(error)) {
            errorHandler(new CancelError());
            return;
        };
        if (error instanceof Error) {
            errorHandler(new ApiError(error.message));
            return;
        }
        if (typeof (error) === 'string') {
            errorHandler(new ApiError(error));
            return;
        }
        errorHandler(new ApiError("An error in request"/*, error*/));
    }

    /*function createBuffer(data: string) {
        let b = new Uint8Array(util.base64.length(data));
        util.base64.decode(data, b, 0);
        return b;
    }*/

    function getServerTimeAsyncForMts(withTokenCheck?: boolean) {
        return new Promise<Date>((f, r) => {
            axios
                .post(
                    `${baseUrl}/getServerTime`,
                    {
                        LanguageID: languageId,
                        Token: token,
                        WithTokenCheck: withTokenCheck === true ? true : undefined,
                        SID: withTokenCheck === true && !params.settings.isDebug ? (params.settings.userSecureId ?? "") : undefined //undefined -> null means do not check
                    },
                    { withCredentials: true }
                )
                .then(response => {
                    if (processApiResponse(response, r)) {
                        f(toDate(response.data.ReturnValue));
                    }
                })
                .catch(error => {
                    processError(error, r);
                });
        });
    }


    return {
        getServerTimeAsyncForMts,
        //processApiResponse,
        //processError,
        //toDate,
        //dateToString,
        setToken: (aToken: string) => {
            token = aToken;
        }
    };
}